import { PAGE_REQUEST } from 'store/app/types';

import { types } from './actions';

const initialState = {
  isOpen: false,
  managedIntegrationUuid: null,
  actionDefinitionUuid: null,
  isEditing: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case PAGE_REQUEST:
      return initialState;
    case types.CLOSE:
      return {
        ...state,
        isOpen: false,
      };
    case types.OPEN:
      return {
        ...state,
        isOpen: true,
        managedIntegrationUuid: payload.managedIntegrationUuid,
        actionDefinitionUuid: payload.actionDefinitionUuid,
        isEditing: payload.isEditing,
      };

    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.common.drawers.createEditActionDefinitionDrawer;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsEditing = (state) => getScope(state).isEditing;

export const getManagedIntegrationUuid = (state) =>
  getScope(state).managedIntegrationUuid;

export const getActionDefinitionUuid = (state) =>
  getScope(state).actionDefinitionUuid;
